import { render, staticRenderFns } from "./SelectUser.vue?vue&type=template&id=036e6bf7&scoped=true&"
import script from "./SelectUser.vue?vue&type=script&lang=js&"
export * from "./SelectUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e6bf7",
  null
  
)

export default component.exports